module.exports = __webpack_public_path__ + "img/gallery-2.ce148258.jpg";